import { render, staticRenderFns } from "./waitError.vue?vue&type=template&id=6012a571"
import script from "./waitError.vue?vue&type=script&lang=js"
export * from "./waitError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports